import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Loading } from "../../components/Loading";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { Context } from "pages/Integrations";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";
import { Checkbox, Select } from "@components";
import { Toggle } from "shared/components/Toggle";

export default class TeknisaDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      active: false,
      environment: "PRODUCTION",
      apiToken: null,
      subsidiaryCode: null,
      allowsSendPhone: true,
      allowsDistinctOnlinePaymentMethods: false,
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  async loadConfigs() {
    const environmentId = EnvironmentStorage.getEnvironment().id;

    const externalCredentials = await EnvironmentsAPI.getConfigurationsByAlias(
      environmentId,
      "external_credentials"
    );
    const configs = externalCredentials.teknisa || {};

    if (Object.keys(configs).length > 0) {
      this.setState({
        active: configs?.active === true,
        environment: configs?.environment || "PRODUCTION",
        apiToken: configs?.apiToken,
        subsidiaryCode: configs?.subsidiaryCode,
        allowsSendPhone: configs?.allowsSendPhone !== false,
        allowsDistinctOnlinePaymentMethods: !!configs?.allowsDistinctOnlinePaymentMethods
      });
    }

    this.setState({
      loadingPage: false,
    });
  }

  async onSave() {
    try {
      const { onSave } = this.props;
      const { active, environment, subsidiaryCode, allowsSendPhone, allowsDistinctOnlinePaymentMethods, apiToken } = this.state;

      this.setState({ loading: true });

      const environmentId = EnvironmentStorage.getEnvironment().id;

      const externalCredentials =
        await EnvironmentsAPI.getConfigurationsByAlias(
          environmentId,
          "external_credentials"
        );
      const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
        environmentId,
        "external_credentials",
        {
          ...externalCredentials,
          teknisa: {
            active,
            environment,
            apiToken,
            subsidiaryCode,
            allowsSendPhone,
            allowsDistinctOnlinePaymentMethods,
          },
        }
      );

      this.setState({ loading: false });

      if (updateResponse.getErrors([]).length === 0) {
        onSave && onSave();
      } else {
        alert({
          text: `Não foi possível alterar a configuração: ${
            updateResponse.getErrors()[0]
          }`,
        });
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const {
      loading,
      loadingPage,
      active,
      environment,
      apiToken,
      subsidiaryCode,
      allowsSendPhone,
      allowsDistinctOnlinePaymentMethods,
    } = this.state;
    const { visible, onClose } = this.props;

    const isValid = environment && subsidiaryCode && apiToken;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title={"Teknisa"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.onSave()}
            loading={loading}
            disabled={loading || !isValid}
          >
            Salvar alterações
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <div className={styles.toggle}>
              <div className="d-flex justify-end w-100">
                <Toggle
                  active={active}
                  onChange={(active) => this.setState({ active })}
                />
              </div>
            </div>

            <Select
              design="two"
              label="Ambiente"
              onChange={(e) => this.setState({ environment: e.target.value })}
              className="mb-20"
              value={environment}
              options={[
                {
                  label: "Produção",
                  value: "PRODUCTION",
                  selected: environment === "PRODUCTION",
                },
                {
                  label: "Homologação",
                  value: "SANDBOX",
                  selected: environment === "SANDBOX",
                },
              ]}
            />

          <Input
              design="two"
              className="mb-20"
              floatLabel="Token da API"
              value={apiToken}
              onChange={(e) =>
                this.setState({ apiToken: e.target.value })
              }
            />

            <Input
              design="two"
              className="mb-20"
              floatLabel="Código da filial"
              value={subsidiaryCode}
              onChange={(e) =>
                this.setState({ subsidiaryCode: e.target.value })
              }
            />

            <Checkbox
              name="allowsSendPhone"
              design="two"
              className="mb-20"
              checked={allowsSendPhone}
              onChange={(e) =>
                this.setState({ allowsSendPhone: !allowsSendPhone })
              }
            >
              Permitir envio do telefone
            </Checkbox>

            <Checkbox
              name="allowsDistinctOnlinePaymentMethods"
              design="two"
              className="mb-20"
              checked={allowsDistinctOnlinePaymentMethods}
              onChange={(e) =>
                this.setState({ allowsDistinctOnlinePaymentMethods: !allowsDistinctOnlinePaymentMethods })
              }
            >
              Permitir envio das bandeiras do pagamento online
            </Checkbox>

            
          </div>
        )}
      </Drawer>
    );
  }
}
